import styled from 'styled-components';

export const TagsWrapper = styled.div`
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 32px;

  @media ${(props) => props.theme.device.mobileL} {
    gap: 8px;
    button {
      margin-top: 8px;
    }
  }
`;

export const InputContainer = styled.div`
  display: flex;
  align-items: center;
  column-gap: 142px;
  row-gap: 32px;
  flex-wrap: wrap;

  @media ${(props) => props.theme.device.mobileL} {
    align-items: start;
    flex-direction: column;

    > div,
    .d-flex {
      width: 100%;
    }
  }
`;
